import React, { useEffect, useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "../api/axiosInstance";
import DashboardLayout from "./DashboardLayout";
import { getNotAnalaysisReceiptData } from "../services/FinancialService";
import { CustomerContext } from "../context/customerContext";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";

const NotAnalysisReceipt = () => {
    const { customer, setCustomer } = useContext(CustomerContext);
    const [receipts, setReceipt] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;
    const navigate = useNavigate();


    useEffect(() => {
        if (!customer?.customerId) return;
        const fetchNotAnalysisReceiptData = async () => {
            try {
                const response = await getNotAnalaysisReceiptData(customer.customerId);
                //   const sortedData = response.data.sort((a, b) => 
                //     new Date(b.agreementDate) - new Date(a.agreementDate) // نزولی
                //  );
                setReceipt(response.data);
                // setCheques(response.data);
            } catch (error) {
                console.error("خطا در دریافت اطلاعات :", error);
            }
        };

        fetchNotAnalysisReceiptData();

    }, [customer]);

    if (!receipts) {
        return (
            <DashboardLayout>
                <div className="text-center text-blue-800">
                    در حال بارگذاری اطلاعات ...
                </div>
            </DashboardLayout>
        );
    }

    // صفحه‌بندی:
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentNotAnalysisReceipt = receipts.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(receipts.length / itemsPerPage);

    return (
        <DashboardLayout>
            <div className="flex items-center justify-between  mb-4">
                <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">لیست واریزی های ثبت نشده</h1>
                <button
                    onClick={() => navigate(-1)}
                    className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
                >
                    بازگشت
                </button>
            </div>
            <div className="w-full overflow-x-auto rounded-xl">
                <table className="w-full min-w-[600px] text-sm text-right bg-white shadow rounded-xl overflow-hidden">
                    <thead className="bg-blue-100 text-blue-900">
                        <tr>
                            <th className="px-2 py-1 sm:p-3">ردیف</th>
                            <th className="px-2 py-1 sm:p-3">نوع واریزی</th>
                            <th className="px-2 py-1 sm:p-3">مبلغ (ریال)</th>
                            <th className="px-2 py-1 sm:p-3">تاریخ</th>

                        </tr>
                    </thead>
                    <tbody>
                        {currentNotAnalysisReceipt.map((receipt, index) => (
                            <tr key={receipt.id} className="border-t hover:bg-blue-50">
                                <td className="px-2 py-1 sm:p-3">{index + 1}</td> {/* شماره ردیف */}
                                <td className="px-2 py-1 sm:p-3">
                                    {
                                        receipt.type === "ReceiptDeposit"
                                            ? "اعلامیه واریز"
                                            : receipt.type === "ReceiptReceivableNote"
                                                ? "چک"
                                                : receipt.type === "ReceiptCashMoney"
                                                    ? "وجه نقد"
                                                    : receipt.type
                                    }
                                </td>
                                <td className="px-2 py-1 sm:p-3">
                                    {receipt.amount.toLocaleString()}

                                </td>

                                <td className="px-2 py-1 sm:p-3">
                                    {new DateObject({
                                        date: receipt.date,
                                        calendar: "gregorian", // مشخص کردن ورودی میلادی
                                    })
                                        .convert(persian) // تبدیل به تقویم شمسی
                                        .format("YYYY/MM/DD")}
                                </td>

                            </tr>
                        ))}
                        {receipts.length === 0 && (
                            <tr>
                                <td colSpan="4" className="p-4 text-center text-gray-500">
                                    واریزی موجود نیست.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {/* صفحه‌بندی */}
            {totalPages > 1 && (
                <div className="flex justify-center gap-2 mt-4 flex-wrap">
                    {/* دکمه قبلی */}
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        className={`px-3 py-1 rounded ${currentPage === 1 ? "bg-gray-300 text-gray-600" : "bg-blue-100"
                            }`}
                    >
                        قبلی
                    </button>

                    {/* صفحه‌ها - فقط ۵ عدد نمایش داده شود */}
                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter((page) => {
                            if (totalPages <= 5) return true;
                            if (currentPage <= 3) return page <= 5;
                            if (currentPage >= totalPages - 2) return page >= totalPages - 4;
                            return Math.abs(currentPage - page) <= 2;
                        })
                        .map((page) => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-3 py-1 rounded ${currentPage === page
                                        ? "bg-blue-600 text-white"
                                        : "bg-gray-200 text-gray-700"
                                    }`}
                            >
                                {page}
                            </button>
                        ))}

                    {/* دکمه بعدی */}
                    <button
                        disabled={currentPage === totalPages}
                        onClick={() =>
                            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                        }
                        className={`px-3 py-1 rounded ${currentPage === totalPages
                                ? "bg-gray-300 text-gray-600"
                                : "bg-blue-100"
                            }`}
                    >
                        بعدی
                    </button>
                </div>
            )}
        </DashboardLayout>
    );
};


export default NotAnalysisReceipt;